import {useRef} from 'react';
import MobilePopup from './MobilePopup';
import useOnClickOutside from '../../../hooks/UseOnClickOutside';

function MobilePopupModal({children, close, showClass, title, list,height='max-content',top , dataCyName, cssStyle=''}) {
    
    const ref = useRef(null);
    
    // Use the enhanced useOnClickOutside hook with condition
    useOnClickOutside(ref, close, showClass && showClass.includes('show'));

    return (  
        <MobilePopup {...{cssStyle, close,showClass, title,list, height, top,dataCyName}} forwardRef={ref} >
            {children}
        </MobilePopup>

    );
}

export default MobilePopupModal;
